function main(){
    var conf = require('./conf.js').init('hola_videojs_hls_provider');
    if (conf.disabled)
        return {disabled: true, attach: function(){}, detach: function(){}};
    var Hls = window.Hls = require('hls.js');
    var provider = require('@hola.org/videojs5-hlsjs-source-handler');
    provider.Hls = Hls;
    provider.version = '1.1.1';
    provider.provider_version = provider.VERSION;
    provider.hls_version = provider.Hls.version;
    provider.hls_params = conf.hls_params;
    if (conf.autoinit)
        provider.attach();
    return provider;
}

try { module.exports = main(); }
catch(e){ module.exports = {init_failure: e}; }
